import { Injectable } from '@angular/core';
import { ApiHttpClient } from 'app/http/clients/api';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})

export class BorrowerContextService {

    constructor(private http: ApiHttpClient) { }

    /**
     * Determine AI generated context and insights for a given borrower.
     * 
     * @param borrowerId
     * @returns Observable
     */
    getBorrowerContext(borrowerId: number): Observable<any> {
        return this.http.get(`${environment.API_URL}/borrower-state/${borrowerId}/waiting-on-role`);
    }
}